import playVideoOnViewPort from "./playVideoOnViewport";

// landing services 
document.getElementById("serv_connect_with_us").onclick = (event) => {
  const page = event.currentTarget.dataset.origin;
  console.log(page);
  gtag("event", "click_connect_with_us_landingpage", {
      user_id: `${cookie}:${ip}`,
      page: `${page}`,
  });
  goToConnect();
};

playVideoOnViewPort();